import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { CreateCustomer, Customer } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createCustomerApi, customerKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UpdateCustomerParams {
  id: string;
  patch: Partial<CreateCustomer>;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUpdateCustomer(): UseMutationResult<Customer, Error, UpdateCustomerParams> {
  const client = useApiClient('deliveries');
  const api = createCustomerApi(client);
  const queryClient = useQueryClient();

  return useMutation<Customer, Error, UpdateCustomerParams>({
    mutationFn: ({ id, patch }: UpdateCustomerParams): Promise<Customer> => api.updateCustomer(id, patch),
    ...createMutationCallbacks({
      invalidateKeys: [customerKeys.all],
      queryClient,
    }),
  });
}
